<template>
    <section class="list-courses container">
        <div class="row">
            <table class="table table-hover w-100 shadow">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Facultad</th>
                        <th scope="col">Tipo</th>
                        <th scope="col">Esfuerzo (horas)</th>
                        <th scope="col">Estado</th>
                        <th scope="col">Acciones</th>
                        <th scope="col">Managers</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="collection-item"
                        v-for="(course, index) in courses"
                        :key="course.id">
                        <th scope="row">{{index+1}}</th>
                        <td>{{course.name}}</td>
                        <td>{{course.entity}}</td>
                        <td>{{course.type}}</td>
                        <td>{{course.effort}}</td>
                        <td v-if="course.status == 1"><span class="badge badge-success">Activo</span></td>
                        <td v-else-if="course.status == 2"><span class="badge badge-danger">Inactivo</span></td>
                        <td v-else><span class="badge badge-secondary">Sin estado</span></td>
                        <td class="row justify-content-around">
                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <span class="btn btn-outline-danger btn-sm" @click="updateCourseItem(course.id, {'status':2})"><font-awesome-icon icon="trash" /></span>
                            </div>
                            <div class="btn-group btn-group-toggle" data-toggle="buttons">
                            <span class="btn btn-outline-info btn-sm" @click="editCourse(course.id, {'status':2})"><font-awesome-icon icon="eye" /></span>
                            </div>
                        </td>
                        <td>
                          <span v-show="currentUser.super || currentUser.admin" class="btn btn-outline-info btn-sm" @click="showManagers(course.id)"><font-awesome-icon icon="users" /></span>
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import firebase from "firebase/app"
import 'firebase/app'
import 'firebase/firestore'

export default {
    name: "ListCourses",
    data() {
        return {
            colId: firebase.auth().currentUser.uid
        };
    },
    created() {
        this.getCourses()
    },
    computed: {
        courses() {
            return this.$store.getters.activeCourses
        },
        ...mapGetters(['currentUser'])

    },
    methods: {
        async getCourses() {
            try {
                await this.$store.dispatch('getCourses')
            } catch (error) {
                console.log('Error al obtener cursos')
            }
        },
        deleteCourse(docId) {
            firebase
                .firestore()
                .collection("courses")
                .doc(docId)
                .delete();
        },
        updateCourseItem(docId, item) {
            firebase
                .firestore()
                .collection("courses")
                .doc(docId)
                .update(item);
        },
        async editCourse(docId, item) {
            try {
                await this.$store.dispatch('getCourseData', docId)
            } catch (error) {
                console.log('Error al obtener cursos')
            }
            this.$store.dispatch("toggleCourseActionTrigger")
            this.$store.commit("setCourseAction", "edit")
            this.$store.dispatch("toggleModalAddCourse")
        },
        async showManagers(course) {
          this.$store.dispatch('getManagerCourse', course)
          this.$store.dispatch("toggleModalManagers")
        }
    }
}

</script>

<style scoped>
.actions-cert {
    cursor: pointer;
}
.shadow {
    background: #fff;
    -webkit-box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ListCourses.vue